<template>
  <div>
    <form @submit.prevent="checkForm()" id="contactForm">
      <div class="form-row">
        <div class="form-group col-sm-6">
          <label class="control-label">Name</label>
          <input v-model="name" type="text" class="form-control" formControlName="name" required />
          <!-- <div class="has-error text-danger" v-if="name.errors && (name.dirty || name.touched)">
            <p v-if="errors.contains('name')">Name is required</p>
          </div>-->
        </div>

        <div class="form-group col-sm-6">
          <label class="control-label col-sm-2">Email</label>
          <input v-model="email" type="email" class="form-control" formControlName="email" required />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-sm-12">
          <label class="control-label">Comment</label>
          <textarea
            v-model="comments"
            type="text"
            rows="5"
            class="form-control"
            formControlName="comments"
            required
          ></textarea>
        </div>
      </div>

      <div class="col-xs-12">
        <button @submit="checkForm()" type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
</template>

<style lang="css">
</style>

<script>
import axios from "axios";

export default {
  name: "ContactUs",
  props: [],
  data() {
    return {
      name: "",
      email: "",
      comments: "",
      errors: [],
      successMsg: ""
    };
  },

  methods: {
    checkForm: async function() {
      // They've got everything filled out
      if (this.name && this.email && this.comments) {
        let contactUsURL =
          "https://bqe5ch4sab.execute-api.us-west-2.amazonaws.com/dev/contact-us";

        let body = JSON.stringify({
          name: this.name,
          email: this.email,
          comments: this.comments
        });

        let options = {
          headers: {
            "Content-Type": "application/json"
          }
        };

        try {
          await axios.post(contactUsURL, body, options);

          this.$el.querySelector("#contactForm").reset();
        } catch (e) {
          console.log(e);
        }
      }
    }
  }
};
</script>